/**
 * LoadingScreen — covers the canvas while assets initialize.
 *
 * Subscribes to UI store progress and disappears once at 100%.
 */

import { html, render } from 'lit-html';
import { useUI } from '@/state/store';

export class LoadingScreen {
  private container: HTMLDivElement;

  constructor() {
    const root = document.getElementById('ui-root')!;
    this.container = document.createElement('div');
    this.container.className = 'loading-screen';
    root.appendChild(this.container);
    useUI.subscribe(() => this.render());
    this.render();
  }

  private render(): void {
    const s = useUI.getState();
    if (s.loadingProgress >= 1) {
      this.container.classList.add('done');
      setTimeout(() => this.container.remove(), 600);
      return;
    }
    const pct = Math.round(s.loadingProgress * 100);
    const tpl = html`
      <div class="ls-inner">
        <div class="ls-title">VIRTUAROO</div>
        <div class="ls-text">${s.loadingText}</div>
        <div class="ls-bar">
          <div class="ls-bar-fill" style="width:${pct}%"></div>
        </div>
        <div class="ls-pct">${pct}%</div>
      </div>
    `;
    render(tpl, this.container);
  }
}
